// Result filter mode to show all data regardless of flags
const ShowAllValue = 'ShowAllValue'
// Result fiter mode to show data without "hide" flags
const ShowValueOnly = 'ShowValueOnly'
export {
  ShowAllValue,
  ShowValueOnly,
}